module.exports = __webpack_public_path__ + "img/content_fallback.289a6278.svg";